import styled from 'styled-components';
import { injectOSXFontSmoothing } from '../../utils/injectOSXFontSmoothing';
import { injectSpacing } from '../../api/spacing/injectSpacing';
const getContainerSize = (size) => {
    const sizeMap = {
        small: '24px',
        medium: '48px',
        large: '96px',
    };
    return `
    height: ${sizeMap[size]};
    width: ${sizeMap[size]};
  `;
};
const getLabelSize = (size) => {
    const sizeMap = {
        small: '10px',
        medium: '16px',
        large: '24px',
    };
    return `
    font-size: ${sizeMap[size]};
  `;
};
export const StyledContainer = styled.span `
  position: relative;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  background-color: ${(props) => props.theme.colors.text.secondary};

  border-radius: 100%;

  ${(props) => getContainerSize(props.size)}
  ${injectSpacing('margin')}
`;
export const StyledImage = styled.img `
  position: absolute;

  display: block;

  width: 100%;
`;
export const StyledLabel = styled.span `
  color: ${(props) => props.theme.colors.form.muted.tertiary};
  font-weight: 550;
  font-family: ${(props) => props.theme.fontFamily};
  line-height: 0;

  ${injectOSXFontSmoothing(true)}
  ${(props) => getLabelSize(props.size)}
`;
//# sourceMappingURL=Avatar.styles.js.map